import React, { useState, Fragment } from 'react';
import { animate } from 'animejs';
import { IconButton } from 'moar-interactive-shared';
import PanZoom from './PanZoom';
import ExpandIcon from './../../Icons/icon-expand.svg?react';

const MediaModule = ({ canExpand, attr, image, imageAltText, zoomText }) => {
  const [pan, setPan] = useState(false);
  const [explorerOpen, setExplorerOpen] = useState(false);

  const openExplorer = () => {
    setPan(true);
    setExplorerOpen(true);
  };

  const closeExplorer = () => {
    const target = document.querySelector('.zoomModal');
    if (!target) {
      setPan(false);
      setExplorerOpen(false);
      return;
    }

    animate(target, {
      ease: 'linear',
      duration: 300,
      opacity: [1, 0],
      onComplete: () => {
        if (canExpand) {
          setPan(false);
          setExplorerOpen(false);
        }
      },
    });
  };

  return (
    <Fragment>
      <div className="media">
        <div className="media__expander">
          <div className="imageComponent">
            {canExpand ? (
              <IconButton icon={<ExpandIcon />} handleClick={() => openExplorer()} />
            ) : null}

            <img className="expander" alt={imageAltText || 'Media Pic'} src={image} />
          </div>
        </div>
      </div>

      {attr ? <p className="media__attr">{attr}</p> : null}

      {pan ? (
        <PanZoom
          zoomText={zoomText}
          explorerOpen={explorerOpen}
          closeExplorer={closeExplorer}
          image={image}
          imageAltText={imageAltText}
        />
      ) : null}
    </Fragment>
  );
};

export default MediaModule;
